export default {
    edit: 'Bearbeiten',
    location: 'Ort + T&C',
    filter: 'Filter',
};
